var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.7285 10.5334C4.66115 11.8131 4.73858 13.1752 3.59529 14.0327C3.06317 14.4318 2.75 15.0581 2.75 15.7233C2.75 16.6382 3.46665 17.4166 4.4 17.4166H17.6C18.5333 17.4166 19.25 16.6382 19.25 15.7233C19.25 15.0581 18.9368 14.4318 18.4047 14.0327C17.2614 13.1752 17.3388 11.8131 17.2715 10.5334C17.0959 7.19785 14.3402 4.58331 11 4.58331C7.65983 4.58331 4.90406 7.19785 4.7285 10.5334Z",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 2.86456C9.625 3.62395 10.2406 4.58331 11 4.58331C11.7594 4.58331 12.375 3.62395 12.375 2.86456C12.375 2.10517 11.7594 1.83331 11 1.83331C10.2406 1.83331 9.625 2.10517 9.625 2.86456Z",
    stroke: "#2177FE",
    strokeWidth: 1.375
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 17.4167C13.75 18.9355 12.5188 20.1667 11 20.1667C9.48122 20.1667 8.25 18.9355 8.25 17.4167",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification01);
export default __webpack_public_path__ + "static/media/notification-01.50af2ef5b1c3cfd5bba0cb0e739e41e4.svg";
export { ForwardRef as ReactComponent };